<template>
  <div class="navbar">
    <h2>Navbar</h2>
    <p>Lorem Ipsum dolor sit.</p>
  </div>
</template>

<script>
export default {
  name: 'Navbar'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
